import React, { useEffect } from 'react';

import { SubscriptionProvider } from 'contexts/SubscriptionContext';
import { UserProvider } from 'contexts/UserContext';
import queryString from 'query-string';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { AuthService } from 'services/auth-service';
import { PosthogService } from 'services/posthog-service';
import { REDIRECT_SEARCH_PARAM_KEY, ROUTE_LINKS } from 'shared/constants/route-links';

export const UnAuthenticatedRouteGuard = () => {
  const location = useLocation();

  if (AuthService.isAuthenticated()) {
    return (
      <UserProvider>
        <SubscriptionProvider>
          <Outlet />
        </SubscriptionProvider>
      </UserProvider>
    );
  }

  const redirectUrl = `${location.pathname}${location.search}`;
  const loginUrl = queryString.stringifyUrl({
    url: ROUTE_LINKS.login,
    query: redirectUrl === '/' ? {} : { [REDIRECT_SEARCH_PARAM_KEY]: redirectUrl }
  });

  return <Navigate to={loginUrl} />;
};

export const AuthenticatedRouteGuard = () => {
  const navigate = useNavigate();
  PosthogService.init();

  useEffect(() => {
    if (AuthService.isAuthenticated()) navigate(ROUTE_LINKS.smartAssistants);
  }, []);

  return !AuthService.isAuthenticated() ? <Outlet /> : <></>;
};
